<div class="pricing-create core-screen">
  <p class="pricing-create__lead">
    {{
      (isEditMode()
        ? 'admin.pricing.domains.' + domain() + '.edit.lead'
        : 'admin.pricing.domains.' + domain() + '.create.lead'
      ) | translate
    }}
  </p>

  @if (loading()) {
    <p class="pricing-create__loading" role="status">
      {{ 'admin.staffQrScan.loading' | translate }}
    </p>
  } @else {
    <form
      [formGroup]="form"
      class="pricing-create__form"
      (ngSubmit)="onSubmit()"
    >
      <section class="pricing-create__section">
        <h2 class="pricing-create__section-title">
          {{ 'admin.pricing.create.metaSection' | translate }}
        </h2>
        <div class="pricing-create__grid">
          <lib-not-input
            type="date"
            [label]="'admin.pricing.create.effectiveFromLabel' | translate"
            formControlName="effectiveFrom"
            [min]="minEffectiveDate"
          />
          <lib-not-input
            type="text"
            [label]="'admin.pricing.create.commentLabel' | translate"
            formControlName="comment"
            [hideErrorBlock]="true"
          />
        </div>
      </section>

      @if (domain() === 'storage') {
        <section class="pricing-create__section" formGroupName="storage">
          <h2 class="pricing-create__section-title">
            {{ 'admin.pricing.create.storageSection' | translate }}
          </h2>
          <div class="pricing-create__grid">
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.baseRateLabel' | translate"
              formControlName="baseRateByndPerM3Day"
              [step]="0.1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.minVolumeLabel' | translate"
              formControlName="minVolumeM3"
              [step]="0.1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.maxPromoDiscountLabel' | translate"
              formControlName="maxPromoDiscountPercent"
              [step]="0.01"
            />
          </div>
        </section>

        <section
          class="pricing-create__section"
          formGroupName="storage"
        >
          <h2 class="pricing-create__section-title">
            {{ 'admin.pricing.create.serviceRatesSection' | translate }}
          </h2>
          <div class="pricing-create__grid" formGroupName="serviceRates">
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.pickupRateLabel' | translate"
              formControlName="pickupByndPerM3"
              [step]="1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.pickupMinVolumeLabel' | translate"
              formControlName="pickupMinVolumeM3"
              [step]="0.1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.returnRateLabel' | translate"
              formControlName="returnByndPerM3"
              [step]="1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.returnMinVolumeLabel' | translate"
              formControlName="returnMinVolumeM3"
              [step]="0.1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.packagingRateLabel' | translate"
              formControlName="packagingByndPerM3"
              [step]="1"
            />
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.packagingMinVolumeLabel' | translate"
              formControlName="packagingMinVolumeM3"
              [step]="0.1"
            />
          </div>
        </section>

        <section
          class="pricing-create__section"
          formArrayName="volumeDiscountTiers"
        >
          <div class="pricing-create__subsection-header">
            <h2 class="pricing-create__section-title">
              {{ 'admin.pricing.create.tiersSection' | translate }}
            </h2>
            <button type="button" class="link-button" (click)="addVolumeTier()">
              + {{ 'admin.pricing.create.addTier' | translate }}
            </button>
          </div>
          @for (tier of volumeDiscountTiers.controls; track $index) {
            <div class="pricing-create__row" [formGroup]="tier">
              <lib-not-input
                type="number"
                [label]="'admin.pricing.create.tierVolumeLabel' | translate"
                formControlName="minVolumeM3"
                [step]="0.1"
              />
              <lib-not-input
                type="number"
                [label]="'admin.pricing.create.tierDiscountLabel' | translate"
                formControlName="discountPercent"
                [step]="0.01"
              />
              <button
                type="button"
                class="link-button link-button--danger"
                (click)="removeVolumeTier($index)"
              >
                {{ 'admin.pricing.create.removeRow' | translate }}
              </button>
            </div>
          }
        </section>

        <section class="pricing-create__section" formGroupName="storage">
          <div class="pricing-create__grid">
            <lib-not-input
              type="number"
              [label]="'admin.pricing.create.maxAutoDiscountLabel' | translate"
              formControlName="maxAutoStandardDiscountPercent"
              [step]="0.01"
            />
          </div>
        </section>
      }

      @if (domain() === 'moving') {
        <section class="pricing-create__section" formGroupName="movingRates">
          <h2 class="pricing-create__section-title">
            {{ 'admin.pricing.create.movingSection' | translate }}
          </h2>
          <div class="pricing-create__grid">
            @for (field of movingRateFields; track field) {
              <lib-not-input
                type="number"
                [label]="movingRateLabel(field)"
                [formControlName]="field"
                [step]="1"
              />
            }
          </div>
        </section>

        <section class="pricing-create__section">
          <h2 class="pricing-create__section-title">
            {{ 'admin.pricing.create.furnitureSection' | translate }}
          </h2>
          <div
            class="pricing-create__subsection"
            formGroupName="disassemblyRates"
          >
            <h3>{{ 'admin.pricing.create.disassemblySection' | translate }}</h3>
            <div class="pricing-create__grid">
              @for (key of furnitureComplexities; track key) {
                <lib-not-input
                  type="number"
                  [label]="furnitureComplexityLabel(key)"
                  [formControlName]="key"
                  [step]="1"
                />
              }
            </div>
          </div>
          <div class="pricing-create__subsection" formGroupName="assemblyRates">
            <h3>{{ 'admin.pricing.create.assemblySection' | translate }}</h3>
            <div class="pricing-create__grid">
              @for (key of furnitureComplexities; track key) {
                <lib-not-input
                  type="number"
                  [label]="furnitureComplexityLabel(key)"
                  [formControlName]="key"
                  [step]="1"
                />
              }
            </div>
          </div>
        </section>
      }

      @if (domain() === 'promocodes') {
        <section class="pricing-create__section" formArrayName="promocodes">
          <div class="pricing-create__subsection-header">
            <h2 class="pricing-create__section-title">
              {{ 'admin.pricing.create.promocodesSection' | translate }}
            </h2>
            <button type="button" class="link-button" (click)="addPromocode()">
              + {{ 'admin.pricing.create.addPromocode' | translate }}
            </button>
          </div>
          @for (promo of promocodes.controls; track $index) {
            <div class="pricing-create__row" [formGroup]="promo">
              <lib-not-input
                type="text"
                [label]="'admin.pricing.create.promocodeLabel' | translate"
                formControlName="promocode"
              />
              <lib-not-input
                type="number"
                [label]="
                  'admin.pricing.create.promocodeDiscountLabel' | translate
                "
                formControlName="discount"
                [step]="1"
              />
              <lib-not-input
                type="number"
                [label]="
                  'admin.pricing.create.promocodeCommissionLabel' | translate
                "
                formControlName="commission"
                [step]="1"
                [hideErrorBlock]="true"
              />
              <button
                type="button"
                class="link-button link-button--danger"
                (click)="removePromocode($index)"
              >
                {{ 'admin.pricing.create.removeRow' | translate }}
              </button>
            </div>
          }
        </section>
      }

      <section class="pricing-create__section pricing-create__section--diff">
        <h2 class="pricing-create__section-title">
          {{ 'admin.pricing.create.diffSection' | translate }}
        </h2>
        @if (hasDiff()) {
          <div class="pricing-create__diff-table" role="table">
            <div
              class="pricing-create__diff-row pricing-create__diff-row--head"
              role="row"
            >
              <span role="columnheader">{{
                'admin.pricing.create.diffPath' | translate
              }}</span>
              <span role="columnheader">{{
                'admin.pricing.create.diffBefore' | translate
              }}</span>
              <span role="columnheader">{{
                'admin.pricing.create.diffAfter' | translate
              }}</span>
            </div>
            @for (entry of diffEntries(); track entry.path) {
              <div
                class="pricing-create__diff-row"
                [class.pricing-create__diff-row--added]="entry.kind === 'added'"
                [class.pricing-create__diff-row--removed]="
                  entry.kind === 'removed'
                "
                [class.pricing-create__diff-row--changed]="
                  entry.kind === 'changed'
                "
                role="row"
              >
                <span class="pricing-create__diff-path" role="cell">{{
                  entry.path
                }}</span>
                <span role="cell">{{ entry.before }}</span>
                <span role="cell">{{ entry.after }}</span>
              </div>
            }
          </div>
        } @else {
          <p class="pricing-create__no-diff">
            {{ 'admin.pricing.create.noDiff' | translate }}
          </p>
        }
      </section>

      <div class="pricing-create__actions">
        <lib-cabinet-button
          variant="primary"
          size="lg"
          [fullWidth]="true"
          [text]="
            (isEditMode()
              ? 'admin.pricing.domains.' + domain() + '.edit.submit'
              : 'admin.pricing.domains.' + domain() + '.create.submit'
            ) | translate
          "
          [action]="{ type: 'action' }"
          [disabled]="submitting() || form.invalid || !canSubmit()"
          [isLoading]="submitting()"
          (actionEvent)="onSubmit()"
        />
      </div>
    </form>
  }
</div>
